import * as Actions from '../Actions/PDFReaderActions';

const initialState = {
    data: null,
    template: null,
    file: null
};

const PDFReaderReducer = function (state = initialState, action) {
    switch (action.type) {

        case Actions.GET_RELATORIO_PDFREADER:
            {
                return {
                    ...state,
                    template: action.payload
                };
            }
        case Actions.RELATORIO_ERROR_PDFREADER:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.GET_FILE_PDF:
            {
                return {
                    ...state,
                    file: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default PDFReaderReducer;
